import vimmiPI from '../plugins/vimmiPI';
import Logger from '../logger';
import vjsSrv from 'src/js/services/vjsSrv';

export class AudioTracksService {

  constructor() {
    this.options = {};
  }

  enableCustomButton(options = {}) {
    this.options = Object.assign({}, this.options, options || {});
    let customTracks = vimmiPI.getActiveAsset().get('mAudio');
    if (customTracks && customTracks.length > 1) {
      let customTracksButton = vjsSrv.vjsPlayer.getChild('ControlBar').getChild('CustomAudioTrackButton');
      if (customTracksButton) {
        customTracksButton.show();
        customTracksButton.update();
      }
    }
  }

  disableCustomButton() {
    let customTracksButton = vjsSrv.vjsPlayer.getChild('ControlBar').getChild('CustomAudioTrackButton');
    if (customTracksButton) {
      customTracksButton.hide();
    }
  }
}

const AudioTracksSrv = new AudioTracksService();
export default AudioTracksSrv;